import React, { Component } from "react";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import VideoView from "../assets-view/VideoView";
import CollectionItemHover from "./CollectionItemHover";
import CollectionMiddleView from "./CollectionMiddleView";
import {
  setSelectItem,
  unsetSelectItem,
  setSelectShareAsset,
  setCheckItem,
  unsetCheckItem
} from "../../actions/ClientAction";
import { individualSelectItem } from "../../actions/IndividualSelectAction";
import { resumeDownload } from "../../actions/DownloadAction";
import { showPermissionModal } from "../../actions/PermissionAction";
import fileextension from "file-extension";
import DocumentView from "../document-view/DocumentView";
import { Icon, Popover, Modal } from "antd";
import ContextMenu from "../context-menu/ContextMenu";
import { isHoverActive } from "../../actions/HoverVerticalAction";
import {
  getImageAssettByExtension,
  getWithDrawer,
  getNewPermission,
  getDeletePermissionName,
  canDeleteAsset,
  IMAGE_EXT
} from "../../utils";
import DownloadAsset from "../assets-download/DownloadAsset";
import { setKeyCollection, setkeyboardEnabled } from "../../actions/AppAction";
import { SVGView } from "../assets-view/SVGView";
import CustomCheckSelector from "../custom-check-selector/CustomCheckSelector";
import {
  updateModalVisibility,
  addItemSelect
} from "../../actions/MultiselectAction";

export class CollectionVertical extends Component {
  constructor(props) {
    super(props);

    this.state = {
      folderColor: "#2E97CF",
      multipleColor: "#444444",
      showDownloadDrawer: false,
      itemSelectedState: null,
      canConvertionFolder: false,
      canDownload: true,
      showMultiDeleteModal: false,
      showModalMultiDownload: false,
      showModalMultiShare: false,
      showModalMultiMove: false,
      selectedRowKeys: [],
      canShare: true,
      canDelete: true,
      canEdit: true,
      canAddFavorite: true,
      canMove: true,
      canPermissions: true,
      canTagsProtocol: true,
      canCommentsAndVersions: false,
      canCreateVersionDart: false,
      canViewVersionsDart: false,
      canBunkeyHost: false,
      canShareLinkBunkeyHost: false
    };
  }

  componentDidMount() {
    const {
      newColor,
      user,
      keyCollection,
      newMatrix,
      // folderselect
      itemSelected
    } = this.props;
    if (newColor) {
      this.setState({
        folderColor: newColor,
        verticalHover: true
      });
      if (newColor < "#500000") {
        this.setState({
          multipleColor: "#E63946"
        });
      } else {
        this.setState({
          multipleColor: "#444444"
        });
      }
    }

    if (keyCollection === "assetsPublicShared") {
      this.setState({
        canDownload: true,
        canShare: false,
        canDelete: false,
        canEdit: false,
        canAddFavorite: false,
        canMove: false,
        canPermissions: false,
        canCommentsAndVersions: false,
        canCreateVersionDart: false,
        canViewVersionsDart: false,
        canBunkeyHost: false,
        canShareLinkBunkeyHost: false,
        canTagsProtocol: false
      });
    } else if (
      user.clientRole !== "admin" &&
      user.role !== "admin" &&
      itemSelected
    ) {
      this.setState({
        canDownload: getNewPermission(itemSelected._id, newMatrix, "download"),
        canEdit: getNewPermission(itemSelected._id, newMatrix, "edit"),
        canDelete: canDeleteAsset(itemSelected, newMatrix),
        canShare: getNewPermission(itemSelected._id, newMatrix, "share"),
        canMove: getNewPermission(itemSelected._id, newMatrix, "move")
      });
    }

    this.setState({
      canConvertionFolder:
        user &&
        user.clientRole === "admin" &&
        user.role === "admin" &&
        (user.email === "jorge@bunkey.tv" || user.email === "victor@bunkey.tv")
    });
  }

  componentDidUpdate(prevProps) {
    const { newColor } = this.props;
    if (prevProps.newColor !== newColor) {
      this.setState({
        folderColor: newColor
      });

      if (newColor < "#500000") {
        this.setState({
          multipleColor: "#E63946"
        });
      } else {
        this.setState({
          multipleColor: "#444444"
        });
      }
    }
  }

  handleMiddleView = r => {
    const { keyCollection, indice, from } = this.props;

    if (r.isSelected === true) {
      this.props.unsetSelectItem(keyCollection);
    } else {
      this.props.setSelectItem(keyCollection, r, from, indice);
    }
  };

  handleCheckAsset = item => {
    const { keyCollection } = this.props;
    if (!item.isCheckMultiple) {
      this.props.setCheckItem(keyCollection, item);
    } else {
      this.props.unsetCheckItem(keyCollection, item);
    }
  };

  handleOnMouseHover = r => {
    const { verticalHover } = this.state;
    if (r.type !== "folder" && r.type !== "bunker")
      this.setState(
        {
          verticalHover: true
        },
        () => this.props.isHoverActive(verticalHover)
      );
  };

  handleSetSrc = r => {
    const { originalURL, lowQualityURL } = r;
    const itemUrl =
      originalURL !== lowQualityURL
        ? lowQualityURL
        : getImageAssettByExtension(r.originalURL);
    return itemUrl;
  };

  handleShowDownloadDrawer = r => {
    this.setState({
      showDownloadDrawer: true,
      itemSelectedState: r
    });
  };
  handleShowTagProtocolModal = r => {
    this.props.individualSelectItem(
      r,
      "tag_protocol",
      this.props.keyCollection
    );
  };

  handleShowRenameModal = r => {
    const { keyCollection } = this.props;
    if (r && r.type === "bunker") {
      this.props.individualSelectItem(r, "rename");
    } else {
      this.props.individualSelectItem(r, "renameFile", keyCollection);
    }
  };

  handleShowMoveModal = r => {
    this.props.individualSelectItem(r, "move", this.props.keyCollection);
  };

  handleShowDeleteModal = r => {
    this.props.individualSelectItem(r, "delete", this.props.keyCollection);
  };
  handleShowShareModal = r => {
    this.props.individualSelectItem(r, "share", this.props.keyCollection);
  };

  handleHideDownloadDrawer = () => {
    this.setState({ showDownloadDrawer: false });
    this.props.setkeyboardEnabled(false);
  };

  handleShowMultiDeleteModal = r => {
    this.setState({
      showMultiDeleteModal: true,
      selectedRowKeys: [r._id]
    });
  };
  handleHiddenMultiDeleteModal = r => {
    this.setState({
      showMultiDeleteModal: false
    });
  };

  handleShowModalMultiShare = r => {
    const { keyCollection, addItemSelect, updateModalVisibility } = this.props;
    addItemSelect(r, keyCollection);
    updateModalVisibility({
      showModalMultiShare: true
    });
  };
  handleShowModalMultiDelete = r => {
    const { keyCollection, addItemSelect, updateModalVisibility } = this.props;
    addItemSelect(r, keyCollection);
    updateModalVisibility({
      showModalMultiDelete: true
    });
  };

  handleShowModalMultiMove = r => {
    const { keyCollection, addItemSelect, updateModalVisibility } = this.props;
    addItemSelect(r, keyCollection);
    updateModalVisibility({
      showModalMultiMove: true
    });
  };
  handleShowModalMultiDownload = r => {
    const { keyCollection, addItemSelect, updateModalVisibility } = this.props;
    addItemSelect(r, keyCollection);
    updateModalVisibility({
      showModalMultiDownload: true
    });
  };

  handleHiddenModalMultiShare = r => {};

  handleShowModalMultiMove = r => {
    this.setState({
      showModalMultiMove: true,
      visibleOptions: false,
      selectedRowKeys: [r._id]
    });
  };

  handleHiddenModalMultiMove = () => {
    this.setState({
      showModalMultiMove: false
    });
  };

  handleShowModalMultiDownload = r => {
    this.props.individualSelectItem(r, "download", this.props.keyCollection);
  };

  handleHiddenModalMultiDownload = () => {
    this.setState({
      showModalMultiDownload: false
    });
  };

  handleShowGroup = r => {
    this.props.individualSelectItem(r, "group");
  };

  handleGetPermissionFileOrFolder = (item_id, newMatrix, permission) => {
    const { user, keyCollection } = this.props;
    if (keyCollection === "assetsPublicShared") {
      if (permission === "download") {
        return true;
      } else {
        return false;
      }
    } else {
      if (user.clientRole !== "admin" && user.role !== "admin") {
        return getNewPermission(item_id, newMatrix, permission);
      } else {
        return true;
      }
    }
  };

  render() {
    const {
      folderColor,
      multipleColor,
      showDownloadDrawer,
      itemSelectedState,
      canConvertionFolder,
      // canDownload,
      // canDelete,
      // canShare,
      // canMove,
      // canEdit,
      canTagsProtocol
    } = this.state;
    const {
      data,
      isHover,
      indice,
      itemSelected,
      keyCollection,
      activeView,
      hoverVerticalView,
      intl,
      newMatrix
    } = this.props;
    let cont = 0;

    return (
      <div className="icon-view">
        <ul>
          {data.map((r, k) => {
            k++;
            if (r.type === "folder" || r.type === "bunker") {
              cont++;
              if (cont > 8) cont = 1;
            }
            return (
              <React.Fragment key={k}>
                <div onMouseEnter={() => this.handleOnMouseHover(r)}>
                  {(r.type === "folder" || r.type === "bunker") &&
                    activeView !== "multiple" && (
                      <ContextMenu
                        keyCollection={keyCollection}
                        item={r}
                        menuItem={[
                          {
                            event: () => {
                              this.props.showPermissionModal(r);
                              this.props.setKeyCollection(keyCollection);
                              this.handleShowGroup(r);
                            },
                            icon: "safety-certificate",
                            text: intl.formatMessage({ id: "groups" })
                          },
                          // canDownload
                          this.handleGetPermissionFileOrFolder(
                            r._id,
                            newMatrix,
                            "download"
                          )
                            ? {
                                event: () =>
                                  r.type === "folder" || r.type === "bunker"
                                    ? this.props.resumeDownload(r._id)
                                    : this.handleShowModalMultiDownload(r),
                                icon: "cloud-download",
                                text: intl.formatMessage({
                                  id: "download_asset"
                                })
                              }
                            : null,
                          // canEdit
                          this.handleGetPermissionFileOrFolder(
                            r._id,
                            newMatrix,
                            "edit"
                          )
                            ? {
                                event: () => this.handleShowRenameModal(r),
                                icon: "edit",
                                text: intl.formatMessage({
                                  id: "rename_asset"
                                })
                              }
                            : null,
                          // canMove
                          this.handleGetPermissionFileOrFolder(
                            r._id,
                            newMatrix,
                            "move"
                          )
                            ? {
                                event: () => this.handleShowMoveModal(r),
                                icon: "logout",
                                text: intl.formatMessage({
                                  id: "move_asset"
                                })
                              }
                            : null,
                          canTagsProtocol &&
                          (r.type === "folder" || r.type === "bunker")
                            ? {
                                event: () => this.handleShowTagProtocolModal(r),
                                icon: "tags",
                                text: "Protocolos de tags"
                              }
                            : null,
                          // canShare
                          this.handleGetPermissionFileOrFolder(
                            r._id,
                            newMatrix,
                            "share"
                          )
                            ? {
                                event: () => this.handleShowShareModal(r),
                                icon: "share-alt",
                                text: intl.formatMessage({
                                  id: "shared_share"
                                })
                              }
                            : null,
                          // canDelete
                          this.handleGetPermissionFileOrFolder(
                            r._id,
                            newMatrix,
                            getDeletePermissionName(r.type)
                          )
                            ? {
                                event: () => this.handleShowDeleteModal(r),
                                icon: "delete",
                                text: intl.formatMessage({
                                  id: "delete_asset"
                                })
                              }
                            : null,
                          canConvertionFolder &&
                          (r.type === "folder" || r.type === "bunker")
                            ? {
                                event: () => {
                                  this.props.convertionFolder(r._id);
                                },
                                icon: "rocket",
                                text: intl.formatMessage({
                                  id: "convetinator_force_conversion"
                                })
                              }
                            : null
                        ]}
                      >
                        <li
                          className={`hand color-${cont}`}
                          style={{ backgroundColor: folderColor }}
                          onClick={() =>
                            this.props.handleOnClickExplore(r._id, r.name)
                          }
                          onMouseEnter={() =>
                            this.props.handleOnMouseEnter(`vertical-${k}`)
                          }
                          onMouseLeave={() =>
                            this.props.handleOnMouseLeave(`vertical-${k}`)
                          }
                        >
                          {/* Icono que muestra popover que describe contenidos del bunker */}
                          {keyCollection === "assetsRoot" &&
                            r.longDescription &&
                            r.longDescription !== "" && (
                              <Popover content={r.longDescription}>
                                <Icon
                                  type="info-circle"
                                  style={{
                                    color: "#fff",
                                    marginTop: "6px",
                                    marginRight: "6px",
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    marginBottom: "-20px"
                                  }}
                                />
                              </Popover>
                            )}

                          {/* Nombre de los Bunkers o Subcarpetas */}
                          {r.name.length > 27 ? (
                            <Popover content={r.name} placement="bottom">
                              <p>{`${r.name.slice(0, 27)}...`}</p>
                            </Popover>
                          ) : (
                            <p>{r.name}</p>
                          )}
                          {keyCollection !== "assetsPublicShared" && (
                            <CustomCheckSelector
                              isHover={isHover}
                              k={k}
                              indice={indice}
                              itemHover={r}
                              hoverDetail={null}
                              keyCollection={keyCollection}
                              from={`vertical`}
                              folderOrBunker={
                                r.type === "folder" || r.type === "bunker"
                              }
                            />
                          )}
                        </li>
                      </ContextMenu>
                    )}
                  {r.type !== "folder" &&
                    r.type !== "bunker" &&
                    activeView !== "multiple" && (
                      <ContextMenu
                        keyCollection={keyCollection}
                        item={r}
                        menuItem={[
                          {
                            event: () => {
                              this.props.showPermissionModal(r);
                              this.props.setKeyCollection(keyCollection);
                              this.handleShowGroup(r);
                            },
                            icon: "safety-certificate",
                            text: intl.formatMessage({ id: "groups" })
                          },
                          // canDownload
                          this.handleGetPermissionFileOrFolder(
                            r._id,
                            newMatrix,
                            "download"
                          )
                            ? {
                                event: () =>
                                  this.handleShowModalMultiDownload(r), // added
                                icon: "cloud-download",
                                text: intl.formatMessage({
                                  id: "download_asset"
                                })
                              }
                            : null,
                          // canEdit
                          this.handleGetPermissionFileOrFolder(
                            r._id,
                            newMatrix,
                            "edit"
                          )
                            ? {
                                event: () => this.handleShowRenameModal(r),
                                icon: "edit",
                                text: intl.formatMessage({
                                  id: "rename_asset"
                                })
                              }
                            : null,
                          // canMove
                          this.handleGetPermissionFileOrFolder(
                            r._id,
                            newMatrix,
                            "move"
                          )
                            ? {
                                event: () => this.handleShowMoveModal(r),
                                icon: "logout",
                                text: intl.formatMessage({
                                  id: "move_asset"
                                })
                              }
                            : null,
                          canTagsProtocol &&
                          (r.type === "folder" || r.type === "bunker")
                            ? {
                                event: () => this.handleShowTagProtocolModal(r),
                                icon: "tags",
                                text: "Protocolos de tags"
                              }
                            : null,
                          // canShare
                          this.handleGetPermissionFileOrFolder(
                            r._id,
                            newMatrix,
                            "share"
                          )
                            ? {
                                event: () => this.handleShowShareModal(r),
                                icon: "share-alt",
                                text: intl.formatMessage({
                                  id: "shared_share"
                                })
                              }
                            : null,
                          // canDelete
                          this.handleGetPermissionFileOrFolder(
                            r._id,
                            newMatrix,
                            getDeletePermissionName(r.type)
                          )
                            ? {
                                event: () => this.handleShowDeleteModal(r),
                                icon: "delete",
                                text: intl.formatMessage({
                                  id: "delete_asset"
                                })
                              }
                            : null
                        ]}
                      >
                        <li
                          onClick={() =>
                            hoverVerticalView ? this.handleMiddleView(r) : ""
                          }
                          className="transparent"
                          style={{ overflow: "hidden" }}
                          onMouseEnter={() =>
                            this.props.handleOnMouseEnter(`vertical-${k}`)
                          }
                          onMouseLeave={() =>
                            this.props.handleOnMouseLeave(`vertical-${k}`)
                          }
                        >
                          {r.type === "image" &&
                            fileextension(r.originalURL) === "svg" && (
                              <SVGView assetId={r._id} src={r.originalURL} />
                            )}
                          {r.type === "image" &&
                            fileextension(r.originalURL) !== "svg" &&
                            IMAGE_EXT.includes(
                              fileextension(r.originalURL)
                            ) && (
                              <img
                                style={{ padding: "10px" }}
                                alt={r.name}
                                src={this.handleSetSrc(r)}
                                onClick={() =>
                                  this.props.handleOnMouseEnter(`vertical-${k}`)
                                }
                                onError={({ currentTarget }) => {
                                  currentTarget.onerror = null; // prevents looping
                                  currentTarget.src =
                                    "/images/extensions/image.png";
                                  currentTarget.className =
                                    "img-asset errorAsset";
                                }}
                              />
                            )}
                          {r.type === "image" &&
                            fileextension(r.originalURL) !== "svg" &&
                            !IMAGE_EXT.includes(
                              fileextension(r.originalURL)
                            ) && (
                              <DocumentView
                                from={`horizontal`}
                                keyCollection={keyCollection}
                                indice={indice}
                                item={r}
                                className="img-asset"
                              />
                            )}
                          {r.type === "document" && (
                            <DocumentView
                              from={`vertical`}
                              keyCollection={keyCollection}
                              indice={indice}
                              item={r}
                              className="img-asset"
                            />
                          )}
                          {r.type === "video" && (
                            <VideoView
                              loop={true}
                              url={r.lowQualityURL}
                              paddingTop={22}
                              isHoverPlay={true}
                              disableDefaultControls={true}
                              muted={true}
                              from={`vertical`}
                              r={r}
                              indice={indice}
                              keyCollection={keyCollection}
                            />
                          )}
                          {r.type === "font" && (
                            <DocumentView
                              from={`vertical`}
                              keyCollection={keyCollection}
                              indice={indice}
                              item={r}
                              className="img-asset"
                            />
                          )}
                          {r.type === "audio" && (
                            <DocumentView
                              from={`vertical`}
                              keyCollection={keyCollection}
                              indice={indice}
                              item={r}
                              className="img-asset"
                            />
                          )}
                          {r.type === "other" && (
                            <DocumentView
                              from={`vertical`}
                              keyCollection={keyCollection}
                              indice={indice}
                              item={r}
                              className="img-asset"
                            />
                          )}
                          {isHover &&
                            activeView !== "multiple" &&
                            `vertical-${k}` === indice && (
                              <CollectionItemHover
                                itemHover={r}
                                from={`vertical`}
                                indice={indice}
                                keyCollection={keyCollection}
                              />
                            )}
                          {keyCollection !== "assetsPublicShared" && (
                            <CustomCheckSelector
                              isHover={isHover}
                              k={k}
                              indice={indice}
                              itemHover={r}
                              hoverDetail={null}
                              keyCollection={keyCollection}
                              from={`vertical`}
                            />
                          )}
                        </li>
                      </ContextMenu>
                    )}
                </div>
                <div onClick={() => this.handleMiddleView(r)}>
                  {/* seleccion multiple */}
                  {(r.type === "folder" || r.type === "bunker") &&
                    activeView === "multiple" && (
                      <li
                        className={`hand color-${cont}`}
                        style={{ backgroundColor: folderColor }}
                        onClick={() => this.handleCheckAsset(r)}
                      >
                        {r.isCheckMultiple ? (
                          <div
                            className="collection-checked"
                            style={{ border: `5px solid ${multipleColor}` }}
                          >
                            <p>{r.name}</p>
                            <Icon
                              style={{
                                position: "absolute",
                                color: multipleColor,
                                bottom: 5,
                                right: 5,
                                fontSize: 24
                              }}
                              type="check-square"
                            />
                          </div>
                        ) : (
                          <p>{r.name}</p>
                        )}
                      </li>
                    )}
                  {r.type !== "folder" &&
                    r.type !== "bunker" &&
                    activeView === "multiple" && (
                      <li
                        className="transparent"
                        style={{ overflow: "hidden" }}
                        onClick={() => this.handleCheckAsset(r)}
                      >
                        {r.isCheckMultiple ? (
                          <div
                            className="collection-checked"
                            style={{ border: `5px solid ${multipleColor}` }}
                          >
                            {r.type === "image" && (
                              <img
                                className="img-asset"
                                style={{ padding: "10px" }}
                                alt={r.name}
                                src={this.handleSetSrc(r)}
                                onClick={() => {
                                  this.props.handleOnMouseEnter(
                                    `vertical-${k}`
                                  );
                                  this.handleMiddleView(r);
                                }}
                              />
                            )}
                            {r.type === "document" && (
                              <DocumentView
                                from={`vertical`}
                                keyCollection={keyCollection}
                                indice={indice}
                                item={r}
                                className="img-asset"
                                onClick={() => this.handleMiddleView(r)}
                              />
                            )}
                            {r.type === "video" && (
                              <VideoView
                                loop={true}
                                url={r.lowQualityURL}
                                paddingTop={22}
                                isHoverPlay={true}
                                disableDefaultControls={true}
                                muted={true}
                                from={`vertical`}
                                r={r}
                                indice={indice}
                                keyCollection={keyCollection}
                                onClick={() => this.handleMiddleView(r)}
                              />
                            )}
                          </div>
                        ) : (
                          <div>
                            {r.type === "image" && (
                              <img
                                className="img-asset"
                                style={{ padding: "10px" }}
                                alt={r.name}
                                src={this.handleSetSrc(r)}
                                onClick={() => {}}
                              />
                            )}
                            {r.type === "document" && <DocumentView item={r} />}
                            {r.type === "video" && (
                              <VideoView
                                loop={true}
                                url={r.lowQualityURL}
                                paddingTop={22}
                                isHoverPlay={true}
                                disableDefaultControls={true}
                                muted={true}
                              />
                            )}
                          </div>
                        )}
                      </li>
                    )}
                </div>
                {itemSelected && r.drawMiddleView && (
                  <CollectionMiddleView
                    from={`vertical`}
                    keyCollection={keyCollection}
                  />
                )}
              </React.Fragment>
            );
          })}
        </ul>
        <Modal
          title={intl.formatMessage({ id: "download_asset" })}
          closable={true}
          width={getWithDrawer()}
          destroyOnClose={true}
          footer={null}
          onCancel={this.handleHideDownloadDrawer}
          onClose={this.handleHideDownloadDrawer}
          visible={showDownloadDrawer}
        >
          <DownloadAsset
            itemSelected={itemSelectedState}
            handleHideDownloadDrawer={this.handleHideDownloadDrawer}
          />
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { keyCollection } = ownProps;
  let object;
  switch (keyCollection) {
    case "assetsRoot":
      object = {
        itemSelected: state.assetsRoot.data.find(r => r.isSelected),
        data: state.assetsRoot.data,
        error: state.assetsRoot.error,
        activeView: state.assetsRoot.activeView,
        folderselect: state.assetsRoot.folderselect
      };
      break;
    case "assetsLastUploads":
      object = {
        itemSelected: state.assetsLastUploads.data.find(r => r.isSelected),
        data: state.assetsLastUploads.data,
        error: state.assetsLastUploads.error,
        activeView: state.assetsLastUploads.activeView,
        folderselect: state.assetsLastUploads.folderselect
      };
      break;
    case "assetsShared":
      object = {
        itemSelected: state.assetsShared.data.find(r => r.isSelected),
        data: state.assetsShared.data,
        error: state.assetsShared.error,
        activeView: state.assetsShared.activeView,
        folderselect: state.assetsShared.folderselect
      };
      break;
    case "assetsFavorites":
      object = {
        itemSelected: state.assetsFavorites.data.find(r => r.isSelected),
        data: state.assetsFavorites.data,
        error: state.assetsFavorites.error,
        activeView: state.assetsFavorites.activeView,
        folderselect: state.assetsFavorites.folderselect
      };
      break;
    case "assetsExplore":
      object = {
        itemSelected: state.assetsExplore.data.find(r => r.isSelected),
        data: state.assetsExplore.data,
        error: state.assetsExplore.error,
        activeView: state.assetsExplore.activeView,
        folderselect: state.assetsExplore.folderselect,
        selectedFiles: state.selectedFiles.data
      };
      break;
    case "searcher":
      object = {
        itemSelected: state.searcher.data.find(r => r.isSelected),
        data: state.searcher.data,
        error: state.searcher.error,
        activeView: state.searcher.activeView,
        folderselect: state.searcher.folderselect
      };
      break;
    case "assetsPublicShared":
      object = {
        itemSelected: state.assetsPublicShared.data.find(r => r.isSelected),
        data: state.assetsPublicShared.data,
        error: state.assetsPublicShared.error,
        folderselect: state.assetsPublicShared.folderselect
      };
      break;

    default:
      object = {};
      break;
  }

  return {
    ...object,
    hoverVerticalView: state.hoverVerticalView.hoverVerticalView,
    newColor:
      state.authUser.user && state.authUser.user.color
        ? state.authUser.user.color
        : "#2E97CF",
    isDownloading: state.downloads.isDownloading,
    user: state.authUser.user,
    matrix: state.group.matrix,
    newMatrix: state.group.newMatrix
  };
};

const mapDispatchToProps = {
  setSelectItem,
  unsetSelectItem,
  setCheckItem,
  unsetCheckItem,
  showPermissionModal,
  isHoverActive,
  setKeyCollection,
  resumeDownload,
  setkeyboardEnabled,
  setSelectShareAsset,
  updateModalVisibility,
  addItemSelect,
  individualSelectItem
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(CollectionVertical))
);
